import { render, staticRenderFns } from "./StudipPagination.vue?vue&type=template&id=5024df88&"
import script from "./StudipPagination.vue?vue&type=script&lang=js&"
export * from "./StudipPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports